import { getLocale } from "../i18n";

/** Compact duration for lists: "1ч 15м" / "1h 15m" / "45м" */
export function formatDuration(minutes: number | null | undefined): string {
  if (minutes == null || !Number.isFinite(minutes) || minutes <= 0) return "";
  const total = Math.round(minutes);
  const h = Math.floor(total / 60);
  const m = total % 60;
  const en = getLocale() === "en";
  if (h > 0 && m > 0) return en ? `${h}h ${m}m` : `${h}ч ${m}м`;
  if (h > 0) return en ? `${h}h` : `${h}ч`;
  return en ? `${m}m` : `${m}м`;
}

export const DURATION_PRESETS = [30, 45, 60, 75, 90, 120] as const;
